import PropTypes from 'prop-types';
import useNewMedicalProvider from '../../hooks/useNewMedicalProvider';
import UploadButtonGroup from '../common/UploadButtonGroup';
import useDropboxUploadHandler from '../../hooks/useDropboxUploadHandler';
import { reportSectionClasses, medicalProviderSectionHeadingClasses } from '../common/formClasses';

const NewMedicalProvider = ({ providerType }) => {
    const {
        fieldName,
        providerName,
        handleProviderNameChange,
        buttonDisplayText,
        isButonDisabled,
        isLoading,
        addMedicalFilesFromArray,
    } = useNewMedicalProvider({ providerType });

    const { handleDropboxSuccess } = useDropboxUploadHandler({
        accept: 'application/pdf',
        onFilesReady: async (validFiles) => {
            await addMedicalFilesFromArray(validFiles);
        }
    });

    return (
        <div className={`${reportSectionClasses} p-6 mb-6`}>
            <h4 className={medicalProviderSectionHeadingClasses}>Add Provider</h4>
            <div className="row">
                <div className="col-md-12">
                    <div className="flex items-end gap-2">
                        <div className="grow relative z-[1]">
                            <div className="form-field">
                                <label className="form-label" htmlFor={fieldName}>Medical Provider / Facility</label>
                                <input
                                    id={fieldName}
                                    type='text'
                                    name={fieldName}
                                    value={providerName}
                                    onChange={handleProviderNameChange}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="md:text-right">
                            <UploadButtonGroup
                                uploadButtonText={buttonDisplayText}
                                uploadButtonProps={{ isBorder: true }}
                                accept="application/pdf"
                                multiple={true}
                                disabled={isButonDisabled}
                                isLoading={isLoading}
                                onFileSelect={(files) => addMedicalFilesFromArray(files.file)}
                                onDropboxSuccess={handleDropboxSuccess}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

NewMedicalProvider.propTypes = {
    providerType: PropTypes.string.isRequired,
};

export default NewMedicalProvider;
